export enum AlertRecapBundleByEnum {
  OBJECT_THEN_OFFICE = "objectThenOffice",
  OBJECT_ONLY = "objectOnly",
  OFFICE_THEN_OBJECT = "officeThenObject",
}
